import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getRegulationsStagesPlanWorksRecomendedStaff: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_STAFF].GET_REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_STAFF,
	},
}